import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type MultipleDocsIconProps = CommonSvgProps

const MultipleDocsIcon: React.FC<MultipleDocsIconProps> = React.forwardRef<
  SVGSVGElement,
  MultipleDocsIconProps
>((props, ref) => (
  <Svg viewBox="0 0 68 82" {...props} ref={ref} color="none">
    <path
      d="M37.875 11.0389H8.83333C7.02102 11.0389 5.28293 11.7589 4.00144 13.0404C2.71994 14.3219 2 16.06 2 17.8723V72.5389C2 74.3513 2.71994 76.0893 4.00144 77.3708C5.28293 78.6523 7.02102 79.3723 8.83333 79.3723H49.8333C51.6456 79.3723 53.3837 78.6523 54.6652 77.3708C55.9467 76.0893 56.6667 74.3513 56.6667 72.5389V29.8306L37.875 11.0389Z"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.875 2H17.8333C16.021 2 14.2829 2.71994 13.0014 4.00144C11.7199 5.28294 11 7.02102 11 8.83333V63.5C11 65.3123 11.7199 67.0504 13.0014 68.3319C14.2829 69.6134 16.021 70.3333 17.8333 70.3333H58.8333C60.6456 70.3333 62.3837 69.6134 63.6652 68.3319C64.9467 67.0504 65.6667 65.3123 65.6667 63.5V20.7917L46.875 2Z"
      fill="white"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.1667 2V22.5H65.6667"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.0001 39.5833H24.6667"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.0001 53.25H24.6667"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.5001 25.9166H24.6667"
      stroke="#7BB835"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
))

MultipleDocsIcon.propTypes = commonPropTypes
MultipleDocsIcon.defaultProps = commonDefaultProps

export default MultipleDocsIcon
